import { Box, CircularProgress, Grid2, useTheme } from "@mui/material";
import { Fornecedores } from "../../types";
import { memoObserver } from "../../utils/memoObserver.utils";
import { CTable } from "../data-display/c-table.component";
import { ModalDeleteFornecedores } from "./modal-delete-fornecedores.component";
import { ModalEditFornecedores } from "./modal-edit-fornecedores.component";
import { ModalFormFornecedores } from "./modal-form-fornecedores.component";

export interface TablePacotesProps {
  data: Fornecedores[];
  loading: boolean;
}

export const TableFornecedores = memoObserver(
  ({ data, loading }: TablePacotesProps) => {
    return (
      <CTable
        title="Fornecedores"
        loading={loading}
        addForm={() => <ModalFormFornecedores />}
        rows={data || []}
        columns={[
          {
            field: "nome",
            headerName: "Nome",
            width: 300,
          },
          {
            field: "email",
            headerName: "Email",
            width: 200,
          },
          {
            field: "telefone",
            headerName: "Telefone",
            width: 160,
          },
          {
            field: "actions",
            headerName: "Ações",
            type: "custom",
            width: 120,
            disableColumnMenu: true,
            sortable: false,
            renderCell(params) {
              return (
                <Grid2 container spacing={1}>
                  <Grid2>
                    <ModalEditFornecedores id={params.row.id} />
                  </Grid2>
                  <Grid2>
                    <ModalDeleteFornecedores data={params.row} />
                  </Grid2>
                </Grid2>
              );
            },
          },
        ]}
      />
    );
  }
);
